// let httpUser = `http://boxuser-dev.dhsf.xqhuyu.com` // 用户测试
let httpUser = `http://user-api.996box.com` // 用户正式
// let httpUser = `http://user-api.996box.com` // 用户

const firstVersoin = `/v1`
const OperationUrl = `/Operation`  // 埋点

let baseUrl = ``
// 是否为开发环境
if (process.env.NODE_ENV === "development") {
    httpUser = ``;
    baseUrl = `/api`
}

export default {
    // 埋点
    operation: {
        // 操作记录
        record: `${httpUser}${firstVersoin}${OperationUrl}/record`,
        // 用户行为记录
        footprint: `${httpUser}${firstVersoin}${OperationUrl}/footprint`,
    }
}
